import { Component, inject, signal } from '@angular/core';
import { TrackingConsentPreferences } from './tracking-consent.interfaces';
import { TrackingService } from '../tracking.service';
import { GoogleTagManagerService } from '../google-analytics/google-tag-manager.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-tracking-consent-banner',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './tracking-consent-banner.component.html',
  styleUrl: './tracking-consent-banner.component.scss',
})
export class TrackingConsentBannerComponent {
  trackingService = inject(TrackingService);
  gtmService = inject(GoogleTagManagerService);

  consentAsked = signal(true);
  showCustomSettings = signal(false);

  preferences: TrackingConsentPreferences = {
    ad_storage: false,
    ad_user_data: false,
    ad_personalization: false,
    analytics_storage: false,
  };

  constructor() {
    // Delay `consentAsked` by 1 "frame" so that banner first gets rendered
    // with `translate-y-full` class attached. If consent hasn't been asked yet,
    // this class is dropped the next frame and the banner slides in animated.
    setTimeout(() => {
      this.consentAsked.set(this.trackingService.getTrackingConsent() !== null);
    });
  }

  acceptAll() {
    this.saveConsent({
      ad_storage: true,
      ad_user_data: true,
      ad_personalization: true,
      analytics_storage: true,
    });
  }

  denyAll() {
    this.saveConsent({
      ad_storage: false,
      ad_user_data: false,
      ad_personalization: false,
      analytics_storage: false,
    });
  }

  saveCustom() {
    this.saveConsent(this.preferences);
  }

  toggleCustomSettings() {
    this.showCustomSettings.update((v) => !v);
  }

  private saveConsent(prefs: TrackingConsentPreferences) {
    this.trackingService.setTrackingConsent(prefs);
    this.gtmService.updateConsent(prefs);
    this.consentAsked.set(true);
    this.showCustomSettings.set(false);
  }
}
